/**************
 Mobile Nav
 ***************/

// mobile slider nested dropdown
// setup Dropdowns
document.querySelectorAll(".sliderNavDropTop").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

/**************
 Dropdowns
 ***************/

// open a dropdown
// pass in the element that was clicked or hovered
function openDropdown(element, mouseOver = false) {

    let target = element.getAttribute("data-target");

    // close all dropdown but this one
    document.querySelectorAll('.dropdownNavItem').forEach(el => {
        if (el.getAttribute("data-target") !== target) {
            el.classList.remove('active');
        }
    });


    // close search if open
    document.querySelector('#headerSearchResults').classList.remove('active');

    // open dropdown nav
    let dropdown = document.querySelector(`.dropdownNavItem[data-target="${target}"]`);
    dropdown.classList.add('active');

    // toggle exit hover area
    // if at least one dropdown is open, show the exit hover area
    let openedDropdown = false;
    document.querySelectorAll('.dropdownNavItem').forEach(el => {
        if (el.classList.contains('active')) {
            openedDropdown = true;
        }
    })
    if (openedDropdown) {
        document.querySelector('#dropdownExit').classList.add("active");
    } else {
        document.querySelector('#dropdownExit').classList.remove("active");
    }
}

// open dropdowns
document.querySelectorAll('.openMenu')?.forEach(function (element) {
    element.addEventListener("mouseover", function () {
        openDropdown(element, true);
    })
    element.addEventListener("click", function () {
        openDropdown(element);
    })
})


// close the dropdown navigation
document.querySelector("#dropdownExit")?.addEventListener("mouseenter", function () {
    this.classList.remove("active");
    document.querySelectorAll('.dropdownNavItem').forEach(element => {
        element.classList.remove('active');
    });
    document.querySelectorAll('.openMenu').forEach(element => {
        element.classList.remove('active');
    });
});


/**************
 Search
 ***************/
const headerSectionId = document.querySelector('#header').dataset.sectionId;


// listen for predictive search
document.querySelector('#headerSearchFormInput').addEventListener('input', async function () {

    let searchTerm = this.value.trim();

    // if no search term, clear results and close dropdown
    if (!searchTerm.length) {
        document.querySelector('#headerSearchResultsContent').innerHTML = '';
        document.querySelector('#headerSearchResults').classList.remove('active');
        return;
    }

    // remove active class from all dropdown nav items
    document.querySelectorAll('.dropdownNavItem').forEach(element => {
        element.classList.remove('active');
    });
    document.querySelector('#dropdownExit').classList.remove("active");


    await fetch(window.Shopify.routes.root + `search/suggest?q=${(searchTerm)}&section_id=${headerSectionId}`)
        .then((response) => {
            return response.text();
        })
        .then((text) => {
            // create temp div to parse html
            const html = document.createElement('div');
            html.innerHTML = text;

            let searchHTML = html.querySelector('#headerSearchResultsContent');

            // insert search results
            if (searchHTML && searchHTML.innerHTML.trim().length) {
                document.querySelector(`#headerSearchResultsContent`).innerHTML = searchHTML.innerHTML;

                // open dropdown for results
                document.querySelector('#headerSearchResults').classList.add('active');


                // if the user clicks anywhere outside the search results, close the dropdown
                document.addEventListener('click', function clickOutside(event) {
                    const isClickInside = document.querySelector('#headerSearchResults').contains(event.target);
                    if (!isClickInside) {
                        document.querySelector('#headerSearchResults').classList.remove('active');
                        document.removeEventListener('click', clickOutside);
                    }
                });

                // if the escape key is pressed, close the dropdown
                document.addEventListener('keydown', function escapeListener(event) {
                    if (event.key === 'Escape') {
                        document.querySelector('#headerSearchResults').classList.remove('active');
                        document.removeEventListener('keydown', escapeListener);
                    }
                });

                // search results mobile nav
                document.querySelectorAll('.headerSearchResultsNavLabelInput').forEach(radio => {
                    radio.addEventListener('change', function () {
                        let target = this.value;

                        // hide all results
                        document.querySelectorAll('.headerSearchResultsContentItem').forEach(item => {
                            item.classList.remove('active');
                        })

                        // show target results
                        document.querySelector(`.headerSearchResultsContentItem[id="${target}"]`).classList.add('active');
                    })
                })

            }

        })
        .catch(e => {
            console.error(e);
        });
});

// listen for search submit
document.querySelector('#headerSearchForm')?.addEventListener('submit', function (e) {
    e.preventDefault();

    let fomData = new FormData(this);
    let searchTerm = fomData.get('q');

    // Empty search
    if (!searchTerm.length) {
        return;
    }

    window.location.href = `/search?q=${(searchTerm)}`

});

